<!-- <template>
  <div>
    <el-time-picker
      @change="onChange"
      is-range
      v-bind="time_attrs"
      v-model="submit_data[data.key]"
      :placeholder="data.desc">
    </el-time-picker>
  </div>
</template>
<script>
  import Common from './js/Common'

  var Js = Common('sls-time')
  Js.mixins = [{
    computed: {
      time_attrs () {
        return this.Data.time_attrs || {}
      }
    },
    methods: {
      onChange (v) {
        this.events.change && this.events.change(v)
      }
    }
  }]
  export default Js
</script> -->

<template>
  <div>
    <el-time-picker
      @change="onChange"
	  is-range
      v-model="dtrange_defaultValue"
      type="timerange"
      value-format="timestamp"
      range-separator="至"
      :start-placeholder="fieldArguments.start_placeholder"
      :end-placeholder="fieldArguments.end_placeholder">
    </el-time-picker>
  </div>
</template>
<script>
  import Common from './js/Common'

  var Js = Common('sls-time-range')
  Js.mixins = [{
    data () {
      return {
        dtrange_defaultValue:[]
      }
    },
    mounted () {
      this.dtrange_defaultValue = this.defaultValue;
    },
    computed: {
      date_time_attrs () {
        return this.Data.date_time_attrs || {}
      }
    },
    methods: {

    },
    watch: {
      defaultValue () {
        
        this.dtrange_defaultValue = this.defaultValue
      },
    }
  }]
  export default Js
</script>



// WEBPACK FOOTER //
// src/components/solely-fields/SlsTimeRange.vue